import React from 'react';
import { ConfigProvider, theme as antTheme } from 'antd';

/**
 * ChatWidget'in kendi Ant Design temasi (mavi).
 * Hem ana sayfada (/) hem embed sayfasinda (/embed) ayni gorunumu saglar.
 */
const WidgetThemeProvider = ({ children }) => (
  <ConfigProvider
    theme={{
      algorithm: antTheme.defaultAlgorithm,
      token: {
        colorPrimary: '#0066FF',
        colorText: '#1A1D26',
        colorBgContainer: '#ffffff',
      },
      components: {
        Input: {
          colorBgContainer: '#F7F8FA',
          colorText: '#1A1D26',
          colorTextPlaceholder: '#9CA3AF',
          colorBorder: '#E8ECF1',
        },
        Form: { labelColor: '#1A1D26' },
        Button: { colorPrimary: '#0066FF' },
      },
    }}
  >
    {children}
  </ConfigProvider>
);

export default WidgetThemeProvider;
